<template>
    <a-tag class="tower-tag" :color="colorProp">
        <a :href="`/tower/?name=${name}`" target="_blank">{{ title }} | {{ ratestr }}</a>
    </a-tag>
</template>

<script>
const colors = [
    '', 'orange', 'blue', 'green', 'red', 'purple'
];

export default {
    props: {
        name: String,
        title: String,
        color: String,
        rate: String,
    },
    computed: {
        colorProp() {
            return colors[this.color];
        },
        ratestr() {
            return this.rate == "0" ? "无评分" : Number(this.rate).toFixed(2)
        },
    }
}
</script>

<style lang="less" scoped>
.tower-tag {
    font-size: 13px;
    padding: 2px 6px;
}
</style>